/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  IProduct,
  IProductAddStockReq,
  IProductAllocation,
  ISearchProductReq,
  ISearchProductRes,
  IUpdateProductAllocation,
} from '../interfaces/product';
import * as baseAdapter from './baseAdapter';

export const queryProducts = async () => {
  const ret = await baseAdapter.get<IProduct[]>('/product');
  return ret;
};

export const queryProduct = async (id: number) => {
  const ret = await baseAdapter.get<IProduct>(`/product/get/${id}`);
  return ret?.data;
};

export const searchProducts = async (req: ISearchProductReq) => {
  const ret = await baseAdapter.post<ISearchProductRes>('/product/gets', req);
  return ret;
};

export const addProduct = async (data: Partial<IProduct>) => {
  const ret = await baseAdapter.post('/product/create', data);
  return ret;
};

export const editProduct = async (data: Partial<IProduct>) => {
  const ret = await baseAdapter.put(`/product/update/${data.id}`, data);
  return ret;
};

export const deleteProduct = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/product/deleteProduct/${id}`);
  return ret;
};

export const addStockProduct = async (req: IProductAddStockReq) => {
  const ret = await baseAdapter.post<any>('/product/rebalance', req);
  return ret;
};

export const importProduct = async (data: IProduct[]) => {
  const ret = await baseAdapter.post<any>(`/product/import`, data);
  return ret;
};

export const queryProductAllocations = async () => {
  const ret = await baseAdapter.get<IProductAllocation[]>(
    '/product/getProductAllocations',
  );
  return ret;
};

export const updateProductAllocations = async (
  data: Partial<IUpdateProductAllocation>[],
) => {
  const ret = await baseAdapter.post<boolean>(
    '/product/updateProductAllocations',
    data,
  );
  return ret;
};
